// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogContent,
  DialogActions,
  Divider,
  Container,
  ListItem,
  ListItemText,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import usePageTitle from "app/pageTitle";
import AppConfig from "appConfig";

function CampaignsIndexPage() {
  const pageTitle = "Campaigns";
  usePageTitle(pageTitle);
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [pageLoaded, setPageLoaded] = useState(false);
  const [campaigns, setCampaigns] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("agents/campaigns/index.json")
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            setCampaigns(result.data.data.campaigns);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`,
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  function navigateOut(campaign) {
    if (campaign.campaign_type === "SALES") {
      navigate(`/campaigns/sell/${campaign.reference}`);
      return;
    }

    if (campaign.campaign_type === "DATA") {
      navigate(`/campaigns/data-capture/${campaign.reference}`);
      return;
    }

    if (campaign.campaign_type === "DAW") {
      navigate(`/activations/display-win/${campaign.reference}`);
      return;
    }

    if (campaign.campaign_type === "PSA") {
      navigate(`/activations/product-sampling/${campaign.reference}`);
      return;
    }
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox mt={2} mb={5}>
        {pageLoaded && (
          <MDBox>
            <MDBox display="flex" justifyContent="space-between" px={1} mb={2}>
              <MDBox pt={0.5}>
                <Icon>list</Icon>
              </MDBox>
              <MDBox>
                <MDTypography variant="caption" fontWeight="regular">
                  My Campaigns
                </MDTypography>
              </MDBox>
            </MDBox>
            {campaigns.length > 0 ? (
              <MDBox>
                {campaigns.map((row) => (
                  <MDBox mb={2.5} onClick={() => navigateOut(row)}>
                    <Card>
                      <MDBox px={1.5} pb={1}>
                        <MDBox display="flex" justifyContent="space-between">
                          <MDBox>
                            <MDTypography
                              variant="caption"
                              fontWeight="regular"
                            >
                              {row.campaign_type_name}
                            </MDTypography>
                          </MDBox>
                          <MDBox pt={1}>
                            <Icon>east</Icon>
                          </MDBox>
                        </MDBox>
                        <Divider />
                        <ListItem mb={2}>
                          <ListItemText
                            primary={
                              <MDTypography variant="h6">
                                {row.title}
                              </MDTypography>
                            }
                            secondary={
                              <MDTypography fontSize={13} fontWeight="light">
                                {row.account.name}
                              </MDTypography>
                            }
                          />
                          <MDBox align="center">
                            <MDBox>
                              <img
                                src={`${AppConfig.api_media_url}${row.account.icon}`}
                                width="24px"
                              />
                            </MDBox>
                          </MDBox>
                        </ListItem>
                      </MDBox>
                    </Card>
                  </MDBox>
                ))}
              </MDBox>
            ) : (
              <MDBox>
                <Card>
                  <MDBox p={2} align="center">
                    <MDTypography variant="body2">
                      No active campaigns for this profile.
                    </MDTypography>
                  </MDBox>
                </Card>
              </MDBox>
            )}
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CampaignsIndexPage;
